<template>
  <div :class="_.container">
    <van-notice-bar
      v-for="(list, listIndex) in groupedData"
      :key="listIndex"
      :class="[_.list, replay[listIndex] && _.replay]"
      :delay="0"
      :speed="60"
      :scrollable="true"
      @replay="() => $set(replay, listIndex, true)"
    >
      <div
        v-for="(item, itemIndex) in list"
        :key="itemIndex"
        :class="_.item"
        :style="{ marginLeft: item.left }"
      >
        {{ item.text }}
      </div>
    </van-notice-bar>
  </div>
</template>

<script>
  import Vue from 'vue'
  import { chunk, random, shuffle } from 'vtils'
  import { pxToRem } from '@/utils'

  export default Vue.extend({
    props: {
      data: {
        type: Array,
        required: true,
      },
    },

    data: () => ({
      replay: {},
    }),

    computed: {
      groupedData() {
        return chunk(
          shuffle(
            this.data.map(text => {
              return {
                text: text,
                left: `${pxToRem(random(8, 100, false))}rem`,
              }
            }),
          ),
          15,
        ).map((list, index) => {
          list[0].left = index === 0 ? '110vw' : `${random(130, 160, false)}vw`
          return list
        })
      },
    },
  })
</script>

<style lang="scss" module>
  .container {
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .list {
      background-color: transparent;
      padding: 0;
      height: 22px;

      .item {
        background: rgba(#9c0000, 0.8);
        border-radius: 100px;
        // border: 1px solid #9c0000;
        font-size: 12px;
        color: #ffffff;
        padding: 0 10px;
        height: 22px;
        box-sizing: border-box;
        display: inline-flex;
        align-items: center;
        justify-content: center;
      }

      &.replay {
        .item {
          &:first-child {
            margin-left: 0 !important;
          }
        }
      }
    }
  }
</style>
